module.exports = __webpack_public_path__ + "img/02-min.502019f2.jpg";